import { Box, Typography } from '@mui/material';
import React, { FC } from 'react';
import { getFormattedTimeSpanTitle } from 'src/routes/Dashboard/view/utils';
import { StatTitleProps } from './types';

const StatTitle: FC<StatTitleProps> = ({ statName, timeSpan, secondary }) => {
  const secondaryContent = secondary
    ? secondary
    : timeSpan
      ? getFormattedTimeSpanTitle(timeSpan)
      : null;
  return (
    <Box display="flex" flexDirection="column" flexWrap="nowrap">
      <Typography
        fontSize={20}
        letterSpacing={-0.5}
        fontWeight={600}
        lineHeight={1}
      >
        {statName}
      </Typography>
      {secondaryContent ? (
        <Typography
          variant="body1"
          fontSize={14}
          letterSpacing={-0.5}
          fontWeight={500}
          color="textSecondary"
        >
          {secondaryContent}
        </Typography>
      ) : null}
    </Box>
  );
};

export default StatTitle;
